export const useMessagingKey = {
  base: ["messages"] as const,
  count: () => [...useMessagingKey.base, "count"] as const,
};
